import { createSynaptik, Store } from 'synaptik';
import * as stores from 'app/stores';

const { Provider, useSynapse, connect, ...synapse } = createSynaptik(stores);

export type Stores = typeof stores;
export { Provider, Store, useSynapse, connect, synapse };
